<div class="gw-space-y-4 gw-p-1">
  <tui-tabs
    [(activeItemIndex)]="activeTabIndex"
    class="gw-border-b gw-border-border-normal"
  >
    <button tuiTab type="button">
      {{ 'features.wallets.view.tabs.overview' | translate }}
    </button>
    <button tuiTab type="button">
      {{ 'features.wallets.view.tabs.integrationRouting' | translate }}
    </button>
  </tui-tabs>

  <div *ngIf="activeTabIndex === 0" class="gw-space-y-6">
    <div class="gw-flex gw-flex-wrap gw-items-center gw-gap-2">
      <span class="gw-text-sm gw-text-text-secondary"> #{{ wallet.id }} </span>
      <span
        *ngIf="wallet.isPrimary"
        class="gw-inline-flex gw-items-center gw-rounded-full gw-bg-accent-primary/10 gw-px-2 gw-py-0.5 gw-text-xs gw-font-medium gw-text-accent-primary"
      >
        {{ 'features.wallets.isPrimary' | translate }}
      </span>
      <ng-container *ngIf="walletBindingScope(wallet) as scope">
        <span
          [tuiStatus]="scope === 'standalone' ? '#2563EB' : '#7C3AED'"
          class="gw-text-xs"
        >
          {{ scope | integrationScope | translate }}
        </span>
      </ng-container>
    </div>

    <div class="gw-grid gw-grid-cols-1 md:gw-grid-cols-2 gw-gap-4">
      <div class="gw-space-y-1">
        <p class="gw-text-xs gw-text-text-secondary gw-m-0">
          {{ 'features.wallets.label' | translate }}
        </p>
        <p class="gw-text-sm gw-text-text-primary gw-m-0">
          {{ wallet.label || '—' }}
        </p>
      </div>

      <div class="gw-space-y-1">
        <p class="gw-text-xs gw-text-text-secondary gw-m-0">
          {{ 'features.wallets.provider' | translate }}
        </p>
        <p class="gw-text-sm gw-text-text-primary gw-m-0">
          {{
            walletProvider(wallet) ? (walletProvider(wallet)! | provider) : '—'
          }}
        </p>
      </div>

      <div class="gw-space-y-1">
        <p class="gw-text-xs gw-text-text-secondary gw-m-0">
          {{ 'features.wallets.agency' | translate }}
        </p>
        <p class="gw-text-sm gw-text-text-primary gw-m-0">
          {{ wallet.agency || '—' }}
        </p>
      </div>

      <div class="gw-space-y-1">
        <p class="gw-text-xs gw-text-text-secondary gw-m-0">
          {{ 'features.wallets.account' | translate }}
        </p>
        <p class="gw-text-sm gw-text-text-primary gw-m-0">
          {{ wallet.account || '—' }}
        </p>
      </div>

      <div class="gw-space-y-1" *ngIf="wallet.holderName">
        <p class="gw-text-xs gw-text-text-secondary gw-m-0">
          {{ 'features.wallets.create.holderName' | translate }}
        </p>
        <p class="gw-text-sm gw-text-text-primary gw-m-0">
          {{ wallet.holderName }}
        </p>
      </div>

      <div class="gw-space-y-1" *ngIf="wallet.ispb">
        <p class="gw-text-xs gw-text-text-secondary gw-m-0">
          {{ 'features.wallets.create.ispb' | translate }}
        </p>
        <p class="gw-text-sm gw-text-text-primary gw-m-0">
          {{ wallet.ispb }}
        </p>
      </div>
    </div>

    <ng-container *ngIf="wallet.pool as pool">
      <div class="gw-space-y-1">
        <p class="gw-text-xs gw-text-text-secondary gw-m-0">
          {{ 'features.wallets.binding.title' | translate }}
        </p>
        <p class="gw-text-sm gw-text-text-primary gw-m-0">
          {{
            'features.wallets.binding.poolLine'
              | translate : {id: pool.id, label: pool.label}
          }}
        </p>
      </div>
    </ng-container>

    <ng-container *ngIf="!wallet.pool && wallet.integration as integration">
      <div class="gw-space-y-1">
        <p class="gw-text-xs gw-text-text-secondary gw-m-0">
          {{ 'features.wallets.binding.title' | translate }}
        </p>
        <p class="gw-text-sm gw-text-text-primary gw-m-0">
          {{
            'features.wallets.binding.integrationLine'
              | translate : {id: integration.id}
          }}
          · {{ integration.provider | provider }}
        </p>
        <p
          *ngIf="integration.description"
          class="gw-text-sm gw-text-text-secondary gw-italic gw-m-0"
        >
          {{ integration.description }}
        </p>
      </div>
    </ng-container>

    <div
      *ngIf="canAssociateIntegration"
      class="gw-flex gw-items-center gw-gap-3 gw-rounded-xl gw-border gw-border-border-normal gw-bg-background-elevation-2 gw-p-4"
    >
      <p class="gw-text-sm gw-text-text-secondary gw-m-0 gw-flex-1">
        {{ 'features.wallets.associate.noBindingHint' | translate }}
      </p>
      <gatewee-button
        type="button"
        variant="primary"
        [title]="'features.wallets.associate.button' | translate"
        (clicked)="openAssociateDialog()"
      ></gatewee-button>
    </div>

    <div
      class="gw-grid gw-grid-cols-1 md:gw-grid-cols-3 gw-gap-4 gw-bg-background-elevation-2 gw-rounded-xl gw-p-4"
    >
      <div class="gw-space-y-1">
        <p class="gw-text-xs gw-text-text-secondary gw-m-0">
          {{ 'features.wallets.availableBalance' | translate }}
        </p>
        <p
          class="gw-text-lg gw-font-semibold gw-text-text-primary gw-m-0 gw-tabular-nums"
        >
          {{
            wallet.availableBalance
              | currency : 'BRL' : 'symbol' : '1.2-2' : 'pt-BR'
          }}
        </p>
      </div>
      <div class="gw-space-y-1">
        <p class="gw-text-xs gw-text-text-secondary gw-m-0">
          {{ 'features.wallets.pendingBalance' | translate }}
        </p>
        <p
          class="gw-text-lg gw-font-semibold gw-text-text-primary gw-m-0 gw-tabular-nums"
        >
          {{
            wallet.pendingBalance
              | currency : 'BRL' : 'symbol' : '1.2-2' : 'pt-BR'
          }}
        </p>
      </div>
      <div class="gw-space-y-1">
        <p class="gw-text-xs gw-text-text-secondary gw-m-0">
          {{ 'features.wallets.withheldBalance' | translate }}
        </p>
        <p
          class="gw-text-lg gw-font-semibold gw-text-text-primary gw-m-0 gw-tabular-nums"
        >
          {{
            wallet.withheldBalance
              | currency : 'BRL' : 'symbol' : '1.2-2' : 'pt-BR'
          }}
        </p>
      </div>
    </div>

    <div class="gw-grid gw-grid-cols-1 md:gw-grid-cols-2 gw-gap-4">
      <div class="gw-space-y-1">
        <p class="gw-text-xs gw-text-text-secondary gw-m-0">
          {{ 'common.table.columns.createdAt' | translate }}
        </p>
        <p class="gw-text-sm gw-text-text-primary gw-m-0">
          {{ wallet.createdAt | date : 'dd/MM/yyyy HH:mm' }}
        </p>
      </div>
      <div class="gw-space-y-1">
        <p class="gw-text-xs gw-text-text-secondary gw-m-0">
          {{ 'common.table.columns.updatedAt' | translate }}
        </p>
        <p class="gw-text-sm gw-text-text-primary gw-m-0">
          {{ wallet.updatedAt | date : 'dd/MM/yyyy HH:mm' }}
        </p>
      </div>
    </div>

    <div class="gw-flex gw-justify-end gw-gap-3 gw-pt-2">
      <gatewee-button
        *ngIf="!wallet.isPrimary"
        type="button"
        variant="secondary"
        [title]="'features.wallets.setPrimary' | translate"
        [disabled]="settingPrimary"
        (clicked)="setPrimary()"
      ></gatewee-button>
      <gatewee-button
        type="button"
        variant="primary"
        [title]="'features.wallets.syncBalance' | translate"
        [disabled]="syncing"
        (clicked)="syncBalance()"
      ></gatewee-button>
    </div>
  </div>

  <div *ngIf="activeTabIndex === 1">
    <app-integration-routing-rules
      [wallet]="wallet"
      [actions]="routingRuleActions"
    ></app-integration-routing-rules>
  </div>
</div>
